export const clientGarmentsColumns = [
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ],
  },
  {
    id: 'nombre',
    label: 'Nombre',
    type: 'text',
    sortable: true,
    required: true,
  },
  {
    id: 'peso',
    label: 'Peso (g)',
    type: 'number',
    sortable: true,
    required: true,
  },
  {
    id: 'areaAlistamiento',
    label: 'Área de Alistamiento',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'toalla', label: 'Toalla' },
      { value: 'lenceria', label: 'Lencería' },
      { value: 'ambos', label: 'Ambos' },
    ],
  },
  {
    id: 'familia',
    label: 'Familia de Prendas',
    type: 'asyncSelect',
    sortable: true,
    required: false,
    fetchOptions: async () => {
      try {
        const { getGarmentFamilies } = await import('@/pages/parametrizacion/garmentFamilies/Services/garmentFamilies.services');
        const response = await getGarmentFamilies({ page: 1, limit: 100, query: { estado: 'Activo' } });
        if (response && response.data) {
          return response.data.map(family => ({
            value: { id: family._id, nombre: family.nombre },
            label: family.nombre,
          }));
        }
        return [];
      } catch (error) {
        console.error('Error cargando familias de prendas:', error);
        return [];
      }
    },
  },
  {
    id: 'actions',
    label: 'Acciones',
    key: 'actions',
    actions: [
      {
        key: 'edit',
        label: 'Editar',
        icon: 'Edit',
        tooltip: 'Editar prenda',
        className: 'text-green-600 hover:text-green-700',
      },
      {
        key: 'delete',
        label: 'Eliminar',
        icon: 'Trash',
        tooltip: 'Eliminar prenda',
        className: 'text-red-600 hover:text-red-700',
      },
    ],
  },
];

export const columnsExcel = [
  { header: 'Nombre', key: 'nombre' },
  { header: 'Peso (g)', key: 'peso' },
  { header: 'Área de Alistamiento', key: 'areaAlistamiento' },
  { header: 'Familia de Prendas', key: 'familia.nombre' },
  { header: 'Estado', key: 'estado' },
];
